import { Fragment } from '@wordpress/element';
import { InspectorControls } from '@wordpress/block-editor';
import { PanelBody, SelectControl } from '@wordpress/components';
import { createHigherOrderComponent } from '@wordpress/compose';
import { addFilter } from '@wordpress/hooks';
import classnames from 'classnames';

const extendedGallery = createHigherOrderComponent((BlockEdit) => {
    return (props) => {
        if (props.name !== 'core/gallery') {
            return <BlockEdit {...props} />;
        }

        const { attributes, setAttributes } = props;
        const { animationType } = attributes;

        return (
            <Fragment>
                <BlockEdit {...props} />
                <InspectorControls>
                    <PanelBody title="🟩 Animation" initialOpen={true}>
                        <SelectControl
                            label="Style"
                            value={animationType}
                            options={[
                                { label: 'None', value: 'none' },
                                { label: 'Carousel (Loop)', value: 'carousel' }
                            ]}
                            onChange={(newAnimationStyle) => setAttributes({ animationType: newAnimationStyle })}
                        />
                    </PanelBody>
                </InspectorControls>
            </Fragment>
        );
    };
}, 'extendedGallery');

/**
    * Add custom element class in save element.
    *
    * @param {Object} extraProps     Block element.
    * @param {Object} blockType      Blocks object.
    * @param {Object} attributes     Blocks attributes.
    *
    * @return {Object} extraProps Modified block element.
    */
function applyExtraClass(extraProps, blockType, attributes) {

    const { animationType } = attributes;
    const allowedBlocks = ['core/gallery'];

    //check if attribute exists for old Gutenberg version compatibility
    //add allowedBlocks restriction
    if (allowedBlocks.includes(blockType.name)) {
        if (animationType === 'carousel') {
            console.log(extraProps, "extraProps");
            extraProps.className = classnames(extraProps.className, 'hc-photobanner');
        } else {
            extraProps.className = classnames(extraProps.className.replace('hc-photobanner', ''));
        }
    }
    return extraProps;
}

addFilter(
    'editor.BlockEdit',
    'humane/extended-gallery',
    extendedGallery
);

// Register new attribute for mobile image URL
// Register new attributes
addFilter(
    'blocks.registerBlockType',
    'humane/extended-gallery-attributes',
    (settings, name) => {
        if (name !== 'core/gallery') {
            return settings;
        }

        return {
            ...settings,
            attributes: {
                ...settings.attributes,
                animationType: {
                    type: 'string',
                    default: ''
                }
            }
        };
    }
);

addFilter(
    'blocks.getSaveContent.extraProps',
    'humane/applyExtraClass',
    applyExtraClass
);

export default extendedGallery;
